/**
 * Font stacks from the reference design: a serif for headings and figures, a sans for body text
 * and a mono for codes. The faces are self-hosted through Fontsource (imported in src/index.js).
 * @since NEXT_VERSION
 */
export const FONT_DISPLAY = '"Source Serif 4 Variable", "Source Serif 4", Georgia, "Times New Roman", serif';
export const FONT_BODY = '"Source Sans 3 Variable", "Source Sans 3", "Segoe UI", system-ui, sans-serif';
export const FONT_MONO = '"Source Code Pro Variable", "Source Code Pro", ui-monospace, Consolas, monospace';

export const DISPLAY_WEIGHT = 600;
export const DISPLAY_TRACKING = "-0.01em";
